module.exports = __webpack_public_path__ + "img/home_jd.17135610.png";